import React, { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import { serverbaselink } from '../Env_Variables';
import { useCookies } from 'react-cookie';
import { Loggedincontext } from '../Loggedincontext';
const API = () => {
    const { headersContext } = useContext(Loggedincontext);
    const [cookies, setCookie] = useCookies();
    const axiosheaders = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    };
    const headers = () => {
        const axiosheaders = {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        };
        var token = cookies['12312easdasdas32131asdsadsadsaqweasd123!@_#!@3123'];
        console.log(token);
        if (token != undefined) {
            axiosheaders['Authorization'] = 'Bearer ' + token;
        }
        return axiosheaders;
    };
    const Roommedgostatus_API = async (axiosdata) => {
        const axiosfetch = axios({
            method: 'post',
            url: serverbaselink + '/api/brooms/roommedgostatus/',
            headers: await headersContext(),
            data: axiosdata,
        });
        return axiosfetch;
    };
    const Roomequipmennts_API = async (axiosdata) => {
        const axiosfetch = axios({
            method: 'post',
            url: serverbaselink + '/api/brooms/a_roomEquip',
            headers: await headersContext(),
            data: axiosdata,
        });
        return axiosfetch;
    };
    const fetchusers_API = async (axiosdata) => {
        const axiosfetch = axios({
            method: 'get',
            url: serverbaselink + '/api/userprofiles/fetchusers',
            headers: await headersContext(),
            params: axiosdata,
        });
        return axiosfetch;
    };
    const FetchSpecializations_API = async (axiosdata) => {
        const axiosfetch = axios({
            method: 'get',
            url: serverbaselink + '/api/specizliations/fetchspecializations/',
            headers: await headersContext(),
            params: axiosdata,
        });
        return axiosfetch;
    };
    const RoomsRequests_API = async (axiosdata) => {
        const axiosfetch = axios({
            method: 'get',
            url: serverbaselink + '/api/brooms/rooms_requests',
            headers: await headersContext(),
            params: axiosdata,
        });
        return axiosfetch;
    };

    const FetchCountries_API = async (axiosdata, hasfiles = false) => {
        const axiosfetch = axios({
            method: 'get',
            url: serverbaselink + '/api/countries/fetchcountries',
            headers: await headersContext(),
            params: axiosdata,
        });
        return axiosfetch;
    };
    const FetchStates_API = async (axiosdata, hasfiles = false) => {
        const axiosfetch = axios({
            method: 'get',
            url: serverbaselink + '/api/countries/fetchstates',
            headers: await headersContext(),
            params: axiosdata,
        });
        return axiosfetch;
    };
    const Fetchcities_API = async (axiosdata, hasfiles = false) => {
        const axiosfetch = axios({
            method: 'get',
            url: serverbaselink + '/api/countries/fetchcities',
            headers: await headersContext(),
            params: axiosdata,
        });
        return axiosfetch;
    };
    const Fetchamenitites_API = async (axiosdata, hasfiles = false) => {
        const axiosfetch = axios({
            method: 'get',
            url: serverbaselink + '/api/brooms/a_ammenities',
            headers: await headersContext(),
            params: axiosdata,
        });
        return axiosfetch;
    };

    const AmenititesMutation_API = async (axiosdata, hasfiles = false) => {
        const axiosfetch = axios({
            method: 'post',
            url: serverbaselink + '/api/brooms/a_ammenities',
            headers: await headersContext(),
            data: axiosdata,
        });
        return axiosfetch;
    };
    const Medgoprem_API = async (axiosdata, hasfiles = false) => {
        const axiosfetch = axios({
            method: 'post',
            url: serverbaselink + '/api/brooms/medgoprem',
            headers: await headersContext(),
            data: axiosdata,
        });
        return axiosfetch;
    };
    const CountriesMutation_API = async (axiosdata, hasfiles = false) => {
        const axiosfetch = axios({
            method: 'post',
            url: serverbaselink + '/api/countries/fetchcountries',
            headers: await headersContext(),
            data: axiosdata,
        });
        return axiosfetch;
    };
    const StatesMutation_API = async (axiosdata, hasfiles = false) => {
        const axiosfetch = axios({
            method: 'post',
            url: serverbaselink + '/api/countries/fetchstates',
            headers: await headersContext(),
            data: axiosdata,
        });
        return axiosfetch;
    };
    const CitiesMutation_API = async (axiosdata, hasfiles = false) => {
        const axiosfetch = axios({
            method: 'post',
            url: serverbaselink + '/api/countries/fetchcities',
            headers: await headersContext(),
            data: axiosdata,
        });
        return axiosfetch;
    };
    const FetchBusinesses_API = async (axiosdata) => {
        const axiosfetch = axios({
            method: 'get',
            url: serverbaselink + '/api/business/FetchBusinessView/',
            headers: await headersContext(),
            params: axiosdata,
        });
        return axiosfetch;
    };
    const FetchRoomsQuery_API = async (axiosdata) => {
        const axiosfetch = axios({
            method: 'get',
            url: serverbaselink + '/api/brooms/allrooms/',
            headers: await headersContext(),
            params: axiosdata,
        });
        return axiosfetch;
    };
    const FetchReservatinsQuery_API = async (axiosdata) => {
        const axiosfetch = axios({
            method: 'get',
            url: serverbaselink + '/api/brooms/adminreservations/',
            headers: await headersContext(),
            params: axiosdata,
        });
        return axiosfetch;
    };

    const ReservatinsCrud_API = async (axiosdata) => {
        const axiosfetch = axios({
            method: 'patch',
            url: serverbaselink + '/api/brooms/adminreservations/',
            headers: await headersContext(),
            data: axiosdata,
        });
        return axiosfetch;
    };

    const userAdd_API = async (axiosdata) => {
        const axiosfetch = axios({
            method: 'post',
            url: serverbaselink + '/api/userprofiles/adduser/',
            headers: await headersContext(),
            data: axiosdata,
        });
        return axiosfetch;
    };
    const userBlock_API = async (axiosdata) => {
        const axiosfetch = axios({
            method: 'post',
            url: serverbaselink + '/api/userprofiles/blockuser/',
            headers: await headersContext(),
            data: axiosdata,
        });
        return axiosfetch;
    };
    const SendPushNotifications_API = async (axiosdata) => {
        const axiosfetch = axios({
            method: 'post',
            url: serverbaselink + '/api/userprofiles/sendnotification/',
            headers: await headersContext(),
            data: axiosdata,
        });
        return axiosfetch;
    };
    const userUpdate_API = async (axiosdata) => {
        const axiosfetch = axios({
            method: 'post',
            url: serverbaselink + '/api/userprofiles/updateaccountinfo/',
            headers: await headersContext(),
            data: axiosdata,
        });
        return axiosfetch;
    };
    const userDelete_API = async (axiosdata) => {
        const axiosfetch = axios({
            method: 'delete',
            url: serverbaselink + '/api/userprofiles/adduser/',
            headers: await headersContext(),
            data: axiosdata,
        });
        return axiosfetch;
    };
    const businessAdd_API = async (axiosdata) => {
        const axiosfetch = axios({
            method: 'post',
            url: serverbaselink + '/api/business/business/',
            headers: await headersContext(),
            data: axiosdata,
        });
        return axiosfetch;
    };
    const businessDelete_API = async (axiosdata) => {
        const axiosfetch = axios({
            method: 'delete',
            url: serverbaselink + '/api/business/business/',
            headers: await headersContext(),
            data: axiosdata,
        });
        return axiosfetch;
    };
    const Updatebusinessattach_API = async (axiosdata) => {
        const axiosfetch = axios({
            method: 'post',
            url: serverbaselink + '/api/business/updatebusinessattach/',
            headers: await headersContext(),
            data: axiosdata,
        });
        return axiosfetch;
    };
    const Addroom_API = async (axiosdata) => {
        const axiosfetch = axios({
            method: 'post',
            url: serverbaselink + '/api/brooms/RoomMainInfo/',
            headers: await headersContext(),
            data: axiosdata,
        });
        return axiosfetch;
    };
    const Updateroomllocation_API = async (axiosdata) => {
        const axiosfetch = axios({
            method: 'post',
            url: serverbaselink + '/api/business/updatecliniclocation/',
            headers: await headersContext(),
            data: axiosdata,
        });
        return axiosfetch;
    };
    const Deleteroom_API = async (axiosdata) => {
        const axiosfetch = axios({
            method: 'delete',
            url: serverbaselink + '/api/brooms/RoomMainInfo/',
            headers: await headersContext(),
            data: axiosdata,
        });
        return axiosfetch;
    };
    const RoomMainUpdateRoomSchedule_API = async (axiosdata) => {
        const axiosfetch = axios({
            method: 'post',
            url: serverbaselink + '/api/brooms/updateroomschedule/',
            headers: await headersContext(),
            data: axiosdata,
        });
        return axiosfetch;
    };
    const UpdateRoomAttachment_API = async (axiosdata) => {
        const axiosfetch = axios({
            method: 'post',
            url: serverbaselink + '/api/brooms/updateroomattachement/',
            headers: await headersContext(),
            data: axiosdata,
        });
        return axiosfetch;
    };

    const guestCrud_API = async (axiosdata) => {
        const axiosfetch = axios({
            method: 'post',
            url: serverbaselink + '/instowner/guestCrud',
            headers: await headersContext(),
            data: axiosdata,
        });
        return axiosfetch;
    };

    const serverbaselink_images = () => {
        return 'https://ik.imagekit.io/iup2hbhfs/';
        // return 'https://medgo2.s3.amazonaws.com/';
    };
    const fetchuseauthorization = async (axiosdata) => {
        axios.defaults.withCredentials = true;
        const axiosfetch = axios({
            method: 'get',
            url: serverbaselink + '/api/UserAuthorizationChecker/',
            headers: await headersContext(),
            data: axiosdata,
        });
        return axiosfetch;
    };

    const Signup_API = async (axiosdata) => {
        const axiosfetch = axios({
            method: 'post',
            url: serverbaselink + '/surfer/Signup',
            headers: await headersContext(),
            data: axiosdata,
        });
        return axiosfetch;
    };

    const logout = async (axiosdata) => {
        const axiosfetch = axios({
            method: 'post',
            url: serverbaselink + '/surfer/logout',
            headers: await headersContext(),
            data: axiosdata,
        });
        return axiosfetch;
    };
    const login_API = async (axiosdata) => {
        const axiosfetch = axios({
            method: 'post',
            url: serverbaselink + '/api/login/',
            headers: await headersContext(),
            data: axiosdata,
        });
        return axiosfetch;
    };
    const sendcustomPushNotif_API = async (axiosdata) => {
        const axiosfetch = axios({
            method: 'post',
            url: serverbaselink + '/api/userprofiles/sendcustomPushNotif/',
            headers: await headersContext(),
            data: axiosdata,
        });
        return axiosfetch;
    };
    const roomgalleryorder_API = async (axiosdata) => {
        const axiosfetch = axios({
            method: 'post',
            url: serverbaselink + '/api/brooms/roomgalleryorder/',
            headers: await headersContext(),
            data: axiosdata,
        });
        return axiosfetch;
    };

    const fetchBusinessRooms_API = async (axiosdata) => {
        axios.defaults.withCredentials = true;
        const axiosfetch = axios({
            method: 'get',
            url: serverbaselink + '/api/brooms/businessrooms/',
            headers: await headersContext(),
            params: axiosdata,
        });
        return axiosfetch;
    };
    const FetchRoomInfo_API = async (axiosdata) => {
        axios.defaults.withCredentials = true;
        const axiosfetch = axios({
            method: 'get',
            url: serverbaselink + '/api/brooms/roominfo/',
            headers: await headersContext(),
            params: axiosdata,
        });
        return axiosfetch;
    };
    const FetchBusinessPublicProfile_API = async (axiosdata) => {
        axios.defaults.withCredentials = true;
        const axiosfetch = axios({
            method: 'get',
            url: serverbaselink + '/api/business/FetchBusinessPublicProfile/',
            headers: await headersContext(),
            params: axiosdata,
        });
        return axiosfetch;
    };
    const FetchBusinessRoomReservations_API = async (axiosdata) => {
        axios.defaults.withCredentials = true;
        const axiosfetch = axios({
            method: 'get',
            url: serverbaselink + '/api/brooms/FetchBusinessRoomReservations/',
            headers: await headersContext(),
            params: axiosdata,
        });
        return axiosfetch;
    };
    const fetchUserinfobyid_API = async (axiosdata) => {
        axios.defaults.withCredentials = true;
        const axiosfetch = axios({
            method: 'get',
            url: serverbaselink + '/api/userprofiles/fetchuserinfobyid',
            headers: await headersContext(),
            params: axiosdata,
        });
        return axiosfetch;
    };

    const FetchUserRoomReservations_API = async (axiosdata) => {
        axios.defaults.withCredentials = true;
        const axiosfetch = axios({
            method: 'get',
            url: serverbaselink + '/api/brooms/FetchUserRoomReservations',
            headers: await headersContext(),
            params: axiosdata,
        });
        return axiosfetch;
    };
    const unfoundroomFilters_API = async (axiosdata) => {
        const axiosfetch = axios({
            method: 'get',
            url: serverbaselink + '/api/brooms/unfoundroomfilters/',
            headers: await headersContext(),
            params: axiosdata,
        });
        return axiosfetch;
    };
    const businesslogs_API = async (axiosdata) => {
        const axiosfetch = axios({
            method: 'get',
            url: serverbaselink + '/api/business/businesslogs/',
            headers: await headersContext(),
            params: axiosdata,
        });
        return axiosfetch;
    };
    const pending_reservations_count_API = async (axiosdata) => {
        const axiosfetch = axios({
            method: 'get',
            url: serverbaselink + '/api/brooms/pending_reservations_count/',
            headers: await headersContext(),
            params: axiosdata,
        });
        return axiosfetch;
    };

    const dateformatter = (date) => {
        // var string = date;

        const options = { year: 'numeric', month: 'numeric', day: 'numeric' };
        return new Date(date).toLocaleDateString(undefined, options);
    };

    const dateformatter1 = (date) => {
        // var string = date;

        const options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', hour12: true };
        return new Date(date).toLocaleDateString(undefined, options);
    };

    return {
        pending_reservations_count_API,
        dateformatter1,
        unfoundroomFilters_API,
        FetchUserRoomReservations_API,
        fetchUserinfobyid_API,
        FetchBusinessRoomReservations_API,
        FetchBusinessPublicProfile_API,
        FetchRoomInfo_API,
        fetchBusinessRooms_API,
        guestCrud_API,
        fetchuseauthorization,
        Signup_API,
        logout,
        login_API,
        fetchusers_API,
        userAdd_API,
        userBlock_API,
        FetchSpecializations_API,
        RoomsRequests_API,
        FetchCountries_API,
        FetchStates_API,
        Fetchcities_API,
        userUpdate_API,
        userDelete_API,
        FetchBusinesses_API,
        businessAdd_API,
        Updatebusinessattach_API,
        serverbaselink_images,
        FetchRoomsQuery_API,
        Addroom_API,
        RoomMainUpdateRoomSchedule_API,
        UpdateRoomAttachment_API,
        FetchReservatinsQuery_API,
        ReservatinsCrud_API,
        businessDelete_API,
        Deleteroom_API,
        Roommedgostatus_API,
        dateformatter,
        SendPushNotifications_API,
        sendcustomPushNotif_API,
        roomgalleryorder_API,
        businesslogs_API,
        Updateroomllocation_API,
        CountriesMutation_API,
        StatesMutation_API,
        CitiesMutation_API,
        Fetchamenitites_API,
        AmenititesMutation_API,
        Roomequipmennts_API,
        Medgoprem_API,
    };
};
export default API;
